import { Dialog } from "@mui/material";

export const BlockUi = () => {
  return <Dialog open hideBackdrop />;
};
